/**
 * Colunas recém-criadas (sem OS) recebem o batch sem sobrescrever colunas já preenchidas.
 */
export function isTechnicianBoardGroupsEmpty(groups) {
  if (!groups || typeof groups !== 'object') return true;
  return Object.values(groups).every((arr) => !Array.isArray(arr) || arr.length === 0);
}

export function mergeCacheIntoEmptyTechnicianGroups(prevGroups, cache, techNames) {
  const prev = prevGroups && typeof prevGroups === 'object' ? prevGroups : {};
  const slice = cache && typeof cache === 'object' ? cache : {};
  if (!Array.isArray(techNames) || techNames.length === 0) return prev;

  let changed = false;
  const next = { ...prev };
  techNames.forEach((name) => {
    if (name == null || name === '') return;
    const cached = slice[name];
    if (isTechnicianBoardGroupsEmpty(cached)) return;
    if (!isTechnicianBoardGroupsEmpty(prev[name])) return;
    next[name] = cached;
    changed = true;
  });
  return changed ? next : prev;
}
